import { createToast } from '@maui/elements'

export const notifySuccess = (title, message = '') => {
  createToast({
    variant: 'success',
    title,
    message: message || 'Your request was submitted successfully',
    duration: 5000,
  })
}

export const notifyError = (title, message) => {
  createToast({
    variant: 'error',
    title,
    message,
    duration: 10_000,
  })
}

// Basic validation
export const validate = (fields) => {
  const invalidFields = []
  Object.keys(fields).forEach((field) => {
    const invalid = !fields[field].value && fields[field].required
    if (invalid) {
      invalidFields.push(field.toString())
    }
    fields[field].valid = !invalid
  })
  return invalidFields
}

export const stripHtml = (html) => {
  if (typeof html !== 'string') {
    return ''
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const timeZones = [
  {
    label: '(GMT-12:00) International Date Line West',
  },
  {
    label: '(GMT-11:00) Midway Island, Samoa',
  },
  {
    label: '(GMT-10:00) Hawaii',
  },
  {
    label: '(GMT-09:00) Alaska',
  },
  {
    label: '(GMT-08:00) Pacific Time (US &amp; Canada)',
  },
  {
    label: '(GMT-08:00) Tijuana, Baja California',
  },
  {
    label: '(GMT-07:00) Arizona',
  },
  {
    label: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
  },
  {
    label: '(GMT-07:00) Mountain Time (US &amp; Canada)',
  },
  {
    label: '(GMT-06:00) Central America',
  },
  {
    label: '(GMT-06:00) Central Time (US &amp; Canada)',
  },
  {
    label: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
  },
  {
    label: '(GMT-06:00) Saskatchewan',
  },
  {
    label: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
  },
  {
    label: '(GMT-05:00) Eastern Time (US &amp; Canada)',
  },
  {
    label: '(GMT-05:00) Indiana (East)',
  },
  {
    label: '(GMT-04:00) Atlantic Time (Canada)',
  },
  {
    label: '(GMT-04:00) Caracas, La Paz',
  },
  {
    label: '(GMT-04:00) Manaus',
  },
  {
    label: '(GMT-04:00) Santiago',
  },
  {
    label: '(GMT-03:30) Newfoundland',
  },
  {
    label: '(GMT-03:00) Brasilia',
  },
  {
    label: '(GMT-03:00) Buenos Aires, Georgetown',
  },
  {
    label: '(GMT-03:00) Greenland',
  },
  {
    label: '(GMT-03:00) Montevideo',
  },
  {
    label: '(GMT-02:00) Mid-Atlantic',
  },
  {
    label: '(GMT-01:00) Cape Verde Is.',
  },
  {
    label: '(GMT-01:00) Azores',
  },
  {
    label: '(GMT+00:00) Casablanca, Monrovia, Reykjavik',
  },
  {
    label: '(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
  },
  {
    label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  },
  {
    label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  },
  {
    label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
  },
  {
    label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
  },
  {
    label: '(GMT+01:00) West Central Africa',
  },
  {
    label: '(GMT+02:00) Amman',
  },
  {
    label: '(GMT+02:00) Athens, Bucharest, Istanbul',
  },
  {
    label: '(GMT+02:00) Beirut',
  },
  {
    label: '(GMT+02:00) Cairo',
  },
  {
    label: '(GMT+02:00) Harare, Pretoria',
  },
  {
    label: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  },
  {
    label: '(GMT+02:00) Jerusalem',
  },
  {
    label: '(GMT+02:00) Minsk',
  },
  {
    label: '(GMT+02:00) Windhoek',
  },
  {
    label: '(GMT+03:00) Kuwait, Riyadh, Baghdad',
  },
  {
    label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
  },
  {
    label: '(GMT+03:00) Nairobi',
  },
  {
    label: '(GMT+03:00) Tbilisi',
  },
  {
    label: '(GMT+03:30) Tehran',
  },
  {
    label: '(GMT+04:00) Abu Dhabi, Muscat',
  },
  {
    label: '(GMT+04:00) Baku',
  },
  {
    label: '(GMT+04:00) Yerevan',
  },
  {
    label: '(GMT+04:30) Kabul',
  },
  {
    label: '(GMT+05:00) Yekaterinburg',
  },
  {
    label: '(GMT+05:00) Islamabad, Karachi, Tashkent',
  },
  {
    label: '(GMT+05:30) Sri Jayawardenapura',
  },
  {
    label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  },
  {
    label: '(GMT+05:45) Kathmandu',
  },
  {
    label: '(GMT+06:00) Almaty, Novosibirsk',
  },
  {
    label: '(GMT+06:00) Astana, Dhaka',
  },
  {
    label: '(GMT+06:30) Yangon (Rangoon)',
  },
  {
    label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
  },
  {
    label: '(GMT+07:00) Krasnoyarsk',
  },
  {
    label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
  },
  {
    label: '(GMT+08:00) Kuala Lumpur, Singapore',
  },
  {
    label: '(GMT+08:00) Irkutsk, Ulaan Bataar',
  },
  {
    label: '(GMT+08:00) Perth',
  },
  {
    label: '(GMT+08:00) Taipei',
  },
  {
    label: '(GMT+09:00) Osaka, Sapporo, Tokyo',
  },
  {
    label: '(GMT+09:00) Seoul',
  },
  {
    label: '(GMT+09:00) Yakutsk',
  },
  {
    label: '(GMT+09:30) Adelaide',
  },
  {
    label: '(GMT+09:30) Darwin',
  },
  {
    label: '(GMT+10:00) Brisbane',
  },
  {
    label: '(GMT+10:00) Canberra, Melbourne, Sydney',
  },
  {
    label: '(GMT+10:00) Hobart',
  },
  {
    label: '(GMT+10:00) Guam, Port Moresby',
  },
  {
    label: '(GMT+10:00) Vladivostok',
  },
  {
    label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
  },
  {
    label: '(GMT+12:00) Auckland, Wellington',
  },
  {
    label: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.',
  },
  {
    label: "(GMT+13:00) Nuku'alofa",
  },
]

export const days = [
  { long: 'Sunday', short: 'Sun.' },
  { long: 'Monday', short: 'Mon.' },
  { long: 'Tuesday', short: 'Tue.' },
  { long: 'Wednesday', short: 'Wed.' },
  { long: 'Thursday', short: 'Thu.' },
  { long: 'Friday', short: 'Fri.' },
  { long: 'Saturday', short: 'Sat.' },
]

export const daysMap = {
  sunday: 'Sun',
  monday: 'Mon',
  tuesday: 'Tues',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat'
}

export const deliveryMethodList = [{ label: 'PDF Attachment' }, { label: 'Doc Attachment' }, { label: 'Phone Call' }, { label: 'Power Point' }]
export const sensitivityLevelList = [{ label: 'Red' }, { label: 'Amber' }, { label: 'Green' }]
export const investigationDetailList = [{ label: 'Speed' }, { label: 'Depth' }, { label: 'Balance' }]
